let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h6IMw"), load("jzQa8"), load("7EorR"), load("St9Nk"), load("3Krgg"), load("34R0T")]).then(() => parcelRequire('f2tcq'));